import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileText, X, House, Coffee, ForkKnife } from "@phosphor-icons/react";

const API = process.env.REACT_APP_BACKEND_URL;
const META = {
  checkin:   { label: "Check-in",   Icon: House,     color: "text-emerald-600" },
  breakfast: { label: "Frühstück",  Icon: Coffee,    color: "text-amber-600"   },
  dinner:    { label: "Abendessen", Icon: ForkKnife, color: "text-red-600"     },
};
const LABELS = {
  vorname:"Vorname", nachname:"Nachname", strasse:"Straße + Hausnr.", plz_ort:"PLZ + Ort",
  land:"Land", staatsangehoerigkeit:"Staatsangehörigkeit", ausweisnummer:"Ausweisnummer",
  telefon:"Telefon", email:"E-Mail", geburtsdatum:"Geburtsdatum", anreise:"Anreise",
  abreise:"Abreise", personen:"Anzahl Personen", gast2:"Gast 2", gast3:"Gast 3", gast4:"Gast 4",
  einwilligung:"DSGVO-Einwilligung", signature:"Unterschrift", name:"Name", zimmer:"Zimmer",
  datum:"Datum", uhrzeit:"Uhrzeit", brot:"Brötchen & Backwaren", eier:"Eier",
  suesses:"Süßes & Aufstriche", muesli:"Müsli & Joghurt", kaese_wurst:"Käse & Wurst",
  extras:"Extras", getraenke:"Getränke", wuensche:"Besondere Wünsche", tag:"Tag",
  tagesgerichte:"Tagesgerichte", alacarte:"À-la-carte", unvertraeglichkeiten:"Besondere Wünsche",
  bemerkungen:"Bemerkungen",
};

export default function FormSubmissionModal({ bookingId, formType, open, onClose }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const meta = META[formType] || {};

  useEffect(() => {
    if (!open || !bookingId || !formType) return;
    setData(null); setErr(null);
    api.get(`/forms/by-booking/${bookingId}/${formType}`)
      .then(r => setData(r.data))
      .catch(e => setErr(e.response?.data?.detail || "Nicht gefunden"));
  }, [open, bookingId, formType]);

  const downloadPdf = () => data && window.open(`${API}/api/forms/submissions/${data.id}/pdf`, "_blank");

  const Icon = meta.Icon;
  return (
    <Dialog open={open} onOpenChange={(o)=>{ if(!o) onClose(); }}>
      <DialogContent className="max-w-2xl max-h-[85vh] flex flex-col" data-testid={`form-detail-${formType}`}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {Icon && <Icon size={22} weight="duotone" className={meta.color} />}
            <span>{meta.label} · {data?.guest_name || "Einsendung"}</span>
          </DialogTitle>
        </DialogHeader>
        {!data && !err && <div className="text-sm text-muted-foreground py-6">Lade Details…</div>}
        {err && <div className="text-sm text-rose-600 py-6">{err}</div>}
        {data && (
          <div className="flex-1 overflow-y-auto text-sm space-y-1 -mx-2 px-2">
            {Object.entries(data.data || {}).map(([k, v]) => {
              if (!v || (Array.isArray(v) && v.length === 0) || v === false) return null;
              const isSig = typeof v === "string" && v.startsWith("data:image");
              const label = LABELS[k] || k.replace(/_/g, " ");
              return (
                <div key={k} className="grid grid-cols-3 gap-3 py-1 border-b border-dashed border-border">
                  <div className="font-semibold text-muted-foreground text-xs uppercase tracking-wide">{label}</div>
                  <div className="col-span-2">
                    {isSig
                      ? <img src={v} alt="Unterschrift" className="max-h-24 border border-border rounded bg-white p-1"/>
                      : (Array.isArray(v) ? v.join(", ") : String(v))}
                  </div>
                </div>
              );
            })}
            <div className="text-xs text-muted-foreground pt-3">
              Eingegangen: {new Date(data.created_at).toLocaleString("de-DE")}
              {data.room_hint && <> · Zimmer: {data.room_hint}</>}
            </div>
          </div>
        )}
        <div className="pt-3 border-t border-border flex justify-between items-center">
          {data
            ? <Button variant="outline" size="sm" onClick={downloadPdf} className="rounded-lg">
                <FileText size={14} weight="bold"/><span className="ml-1">PDF öffnen</span>
              </Button>
            : <div/>}
          <Button variant="outline" size="sm" onClick={onClose} className="rounded-lg">
            <X size={14} weight="bold"/><span className="ml-1">Schließen</span>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
